/**
 * DOG OWNED — collection filtering.
 *
 * The filter form is a plain GET form and works without this file. Everything
 * here is enhancement: a modal drawer on mobile, auto-submit on change, and
 * focus management. No filtering logic lives in JavaScript — Shopify's
 * collection.filters API is the only source of truth.
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';

  function setup(toolbar) {
    var form = toolbar.querySelector('[data-filter-form]');
    var panel = toolbar.querySelector('[data-filter-panel]');
    var openBtn = toolbar.querySelector('[data-filter-open]');
    var closeBtn = toolbar.querySelector('[data-filter-close]');
    if (!form) return;

    // Auto-submit is only safe with scripting; without it the Apply button and
    // the noscript sort button do the work.
    form.addEventListener('change', function (event) {
      if (!event.target.matches('[data-filter-auto]')) return;
      if (!isDesktop() && panel && panel.classList.contains('is-open')) return;
      form.submit();
    });

    function isDesktop() {
      return window.matchMedia(DESKTOP).matches;
    }

    if (!panel || !openBtn) return;

    function open() {
      panel.classList.add('is-open');
      document.documentElement.setAttribute('scroll-lock', '');
      openBtn.setAttribute('aria-expanded', 'true');
      var target = closeBtn || panel.querySelector('input, select, button');
      if (target) target.focus();
    }

    function close(refocus) {
      panel.classList.remove('is-open');
      document.documentElement.removeAttribute('scroll-lock');
      openBtn.setAttribute('aria-expanded', 'false');
      if (refocus) openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });

    panel.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!panel.classList.contains('is-open')) return;
      event.preventDefault();
      close(true);
    });

    // Keep Tab inside the drawer while it is acting as a modal.
    panel.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      if (!panel.classList.contains('is-open')) return;
      var focusable = panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var visible = Array.prototype.filter.call(focusable, function (el) {
        return el.offsetParent !== null;
      });
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var mq = window.matchMedia(DESKTOP);
    var onChange = function (event) {
      if (event.matches) close(false);
    };
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
  }

  function init(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-collection-toolbar]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
